export const manifest = {
  screens: {
    scr_2etf1r: { name: "Homepage", route: "/", position: {"x":160,"y":220} },
    scr_84f6bf: { name: "Reader-to-Revenue Score", route: "/", state: {"isDiagnosticOpen":true}, position: {"x":1560,"y":220} },
    scr_0lqlag: { name: "Score link empty state", route: "/score", position: {"x":2960,"y":220} },
  },
  sections: {
    sec_4qoh37: { name: "Reader-to-Revenue Score", x: 0, y: 0, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_4qoh37", children: [
      { kind: "screen", id: "scr_2etf1r" },
      { kind: "screen", id: "scr_84f6bf" },
      { kind: "screen", id: "scr_0lqlag" },
    ] },
  ],
}
